import { EqlField, EqlFieldValueType, ObjectType } from 'generated/graphql';

export const INTEGRATION_DETAIL_TOOLTIP_TITLE = 'Click to copy';

export const MAX_IMPORTANT_METADATA_COUNT = 2;

export const STAR_METADATA_VISIBILITY_OFF_MESSAGE =
  "This metadata can't be starred as the visibility has been toggled off.";

export const STAR_METADATA_MAX_LIMIT_MESSAGE = `You have already starred the maximum of ${MAX_IMPORTANT_METADATA_COUNT} fields for this source. Please deselect others to star this.`;

export const LINK_METADATA_USER_ID_FIELD_OPTION: EqlField = {
  field: 'user_metadata.record.origin_record_id',
  displayName: 'ID',
  valueType: EqlFieldValueType.String,
  isMultiValue: false,
  objectType: ObjectType.User,
};

export const LINK_METADATA_ACCOUNT_ID_FIELD_OPTION: EqlField = {
  field: 'account_metadata.record.origin_record_id',
  displayName: 'ID',
  valueType: EqlFieldValueType.String,
  isMultiValue: false,
  objectType: ObjectType.Account,
};

export const PRIVATE_DISCORD_CONNECTION_HELP_CENTER_DOC =
  'https://helpcenter.enterpret.com/en/articles/6554381-discord#h_7e71bbc7ac';
